import styles from "../../styles/common/CustomLink.module.scss";

import React, {ReactNode} from 'react';
import {Link} from "react-router-dom";
import clsx from "clsx";

interface CustomLinkProps {
  extraClassName?: string;
  url: string;
  isExternal?: boolean;
  text?: string;
  title?: string;
  icon?: ReactNode;
  iconPlacement?: "left";
  linkStyle?: "reverse" //underline on hover
  children?: ReactNode;
}

function CustomLink(
  {
    extraClassName,
    url,
    isExternal,
    text,
    title,
    icon,
    iconPlacement,
    linkStyle,
    children,
  }: CustomLinkProps) {
  return (
    <Link
      className={clsx(styles.cLink, "c-link", extraClassName)}
      to={url}
      target={isExternal? "_blank" : undefined}
      rel={isExternal? "noreferrer noopener": undefined}
      title={title ?? text ?? "Button Title"}
      data-link-style={linkStyle}
    >
      {icon && <i>{icon}</i>}
      {text ? <span><em>{text}</em></span> : children}
    </Link>
  );
}

export default CustomLink;